import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { SORT_DIRECTION } from '../../../../utils/common'
import { exportFile, getScreeningPrice } from './thunk'

const initialState = {
  views: [], // [{ screeningIndicatorId, year, groupId }]
  numberOfCompanies: 0,
  sortBy: {
    screeningIndicatorId: null,
    year: null,
    sortDirection: SORT_DIRECTION.ASC,
  },
  currencies: [],
  languageCode: null,

  screeningPrice: {},
  discountInfo: {
    typeRadio: false,
    discountId: null,
    voucherCode: '',
    percentage: 0,
    discountAmount: 0,
  },

  errors: {
    numberOfCompanies: false,
  },

  loadingExport: false,
  loadingPrice: false,
}

export const slice = createSlice({
  name: 'tool/screening/exportFileSetting',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeViews: (state, action) => {
      state.views = action.payload
    },
    changeNumberOfCompany: (state, action) => {
      state.numberOfCompanies = action.payload
    },
    changeSortBy: (state, action) => {
      state.sortBy = action.payload
    },
    changeCurrencies: (state, action) => {
      state.currencies = action.payload
    },
    changeLanguageCode: (state, action) => {
      state.languageCode = action.payload
    },
    changeDiscountInfo: (state, action) => {
      state.discountInfo = { ...state.discountInfo, ...action.payload }
    },
    validateExport: (state, action) => {
      const { callback } = action.payload
      if (!state.numberOfCompanies || state.numberOfCompanies <= 0) {
        state.errors.numberOfCompanies = true
        callback(false)
      } else {
        callback(true)
      }
    },
    changeError: (state, action) => {
      const { key, value } = action.payload
      state.errors[key] = value
    },
  },
  extraReducers: (builder) => {
    // getScreeningPrice
    builder.addCase(getScreeningPrice.pending, (state) => {
      state.loadingPrice = true
    })
    builder.addCase(getScreeningPrice.fulfilled, (state, { payload = {} }) => {
      state.screeningPrice = payload
      state.loadingPrice = false
    })
    builder.addCase(getScreeningPrice.rejected, (state, action) => {
      state.loadingPrice = action.payload.loading
    })
    // exportFile
    builder.addCase(exportFile.pending, (state) => {
      state.loadingExport = true
    })
    builder.addCase(exportFile.fulfilled, (state, action) => {
      state.loadingExport = false
    })
    builder.addCase(exportFile.rejected, (state, action) => {
      state.loadingExport = action.payload.loading
    })
  },
})

export const selectViews = (state) => state[slice.name].views
export const selectViewsCount = (state) => {
  const viewsData = state[slice.name].views
  return viewsData.filter(
    (item, index) =>
      viewsData.findIndex((view) => view.groupId === item.groupId) === index,
  ).length
}
export const selectNumberOfCompany = (state) =>
  state[slice.name].numberOfCompanies
export const selectSortBy = (state) => state[slice.name].sortBy
export const selectCurrencies = (state) => state[slice.name].currencies
export const selectLanguageCode = (state) => state[slice.name].languageCode
export const selectError = (key) => (state) => state[slice.name].errors[key]

export const selectScreeningPrice = (state) => state[slice.name].screeningPrice
export const selectDiscountInfo = (state) => state[slice.name].discountInfo

export const selectLoadingExport = (state) => state[slice.name].loadingExport
export const selectLoadingPrice = (state) => state[slice.name].loadingPrice

export const {
  resetStore,
  changeViews,
  changeNumberOfCompany,
  changeSortBy,
  changeCurrencies,
  changeLanguageCode,
  changeDiscountInfo,
  validateExport,
  changeError,
} = slice.actions

register(slice.name, slice.reducer)
